module.exports = __webpack_public_path__ + "img/大数据平台数据清洗.d89f7d9c.jpg";